<div class="modal-header">
    <button type="button" class="close" (click)="onClose()">&times;</button>
  </div>
  
  <div class="modal-body">
    <form (ngSubmit)="submitForm()" #form="ngForm">
      <div class="add_category_cnt">
        <label>First Name :</label>
        <input type="text" [(ngModel)]="staffData.name" name="name" class="form-control" required />
      </div>
      <div class="add_category_cnt">
        <label>Email :</label>
        <input type="email" [(ngModel)]="staffData.email" name="email" class="form-control" required />
      </div>
      <div class="add_category_cnt">
        <label>Mobile :</label>
        <input type="text" [(ngModel)]="staffData.mobile" name="mobile" class="form-control" required />
      </div>
      <div class="add_category_cnt">
        <label>City :</label>
        <input type="text" [(ngModel)]="staffData.city" name="city" class="form-control" />
      </div>
      <div class="add_category_cnt">
        <label>District :</label>
        <input type="text" [(ngModel)]="staffData.district" name="district" class="form-control" />
      </div>
      <div class="add_category_cnt mt-3">
        <button type="submit" class="btn btn-primary">Submit</button>
      </div>
    </form>
  </div>
  